import React from "react";
import { ReactTypeformEmbed } from "react-typeform-embed";

import CareSolvedOption from "components/care_solved/CareSolvedOption";
import SegmentClient from "clients/SegmentClient";
import supercarersIcon from "icons/care-match.png";

function CareMatch() {
  let typeformEmbed = React.createRef();

  const openForm = () => {
    SegmentClient.trackEvent({
      event: "vitality begin search click",
      eventCategory: "pre-user activation",
      eventAction: "vitality begin search click",
      eventLabel: "click"
    });

    typeformEmbed.typeform.open();
  };

  return (
    <>
      <ReactTypeformEmbed
        popup
        autoOpen={false}
        url="https://supercarersagencies.typeform.com/to/zyDzLI"
        hideHeaders
        hideFooter
        buttonText="Get Started"
        ref={tf => {
          typeformEmbed = tf;
        }}
        style={{ visibility: "hidden" }}
      />
      <CareSolvedOption
        buttonAction={openForm}
        buttonLabel="Begin Search"
        description="Tell us about your needs, and we will match you to the care solution that is most suitable to you."
        icon={supercarersIcon}
        name="CareMatch"
      />
    </>
  );
}

export default CareMatch;
